import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Simulator from "@/pages/Simulator";
import Rules from "@/pages/Rules";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n";

export default function App() {
  return (
    <I18nProvider>
      <div className="App bg-ambient bg-noise relative min-h-screen">
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/simulator" element={<Simulator />} />
              <Route path="/rules" element={<Rules />} />
            </Routes>
          </Layout>
        </BrowserRouter>
        <Toaster theme="dark" />
      </div>
    </I18nProvider>
  );
}
